import { jsxs as M, jsx as i } from "react/jsx-runtime";
import { Select as q } from "../Select/index.js";
import { ChevronLeftFAIcon as F, ChevronRightFAIcon as G } from "../Icons/index.js";
import { G as N } from "../../Group-CbE78j-X.js";
import { T } from "../../Text-B7Ta53Id.js";
import '../../assets/index23.css';const L = "Pagination-module__root___q6uHB", P = "Pagination-module__paginationButton___xq1xT", $ = "Pagination-module__dots___S8Ja6", C = "Pagination-module__navButton___UTm5I", H = "Pagination-module__itemsPerPage___XuM8O", h = {
  root: L,
  paginationButton: P,
  dots: $,
  navButton: C,
  itemsPerPage: H
}, X = ({
  total: o,
  value: s,
  onChange: g,
  boundaries: c = 1,
  siblings: p = 1,
  disabled: u = !1,
  "data-plum-id": j,
  className: k,
  withItemsPerPage: z = !1,
  totalItems: l = 0,
  itemsPerPage: x = 10,
  itemsPerPageOptions: v = [10, 25, 50, 100],
  onItemsPerPageChange: B
}) => {
  const a = (n, t) => {
    const E = t - n + 1;
    return Array.from({ length: E }, (m, _) => _ + n);
  }, f = (n) => /* @__PURE__ */ i("span", { className: h.dots, children: "•••" }, n), e = (n) => /* @__PURE__ */ i(
    "button",
    {
      className: h.paginationButton,
      onClick: () => g(n),
      disabled: u,
      "data-active": n === s,
      type: "button",
      children: n
    },
    n
  ), w = () => {
    const n = a(1, o), t = [];
    t.push(
      /* @__PURE__ */ i(
        "button",
        {
          className: h.navButton,
          onClick: () => g(s - 1),
          disabled: u || s === 1,
          type: "button",
          children: /* @__PURE__ */ i(F, { size: 14 })
        },
        "prev"
      )
    );
    const E = c * 2 + p * 2 + 1;
    if (o <= E)
      n.forEach((m) => t.push(e(m)));
    else {
      const m = Math.max(s - p, c), _ = Math.min(s + p, o - c + 1), y = m > c + 2, R = _ < o - (c + 1);
      if (!y && R) {
        const r = 3 + 2 * p;
        a(1, r).forEach((S) => t.push(e(S))), t.push(f("dots-1")), a(o - (c - 1), o).forEach(
          (S) => t.push(e(S))
        );
      } else y && !R ? (a(1, c).forEach(
        (d) => t.push(e(d))
      ), t.push(f("dots-2")), a(
        o - (2 + 2 * p),
        o
      ).forEach((d) => t.push(e(d)))) : y && R && (a(1, c).forEach(
        (r) => t.push(e(r))
      ), t.push(f("dots-3")), a(m, _).forEach(
        (r) => t.push(e(r))
      ), t.push(f("dots-4")), a(o - (c - 1), o).forEach(
        (r) => t.push(e(r))
      ));
    }
    return t.push(
      /* @__PURE__ */ i(
        "button",
        {
          className: h.navButton,
          onClick: () => g(s + 1),
          disabled: u || s === o,
          type: "button",
          children: /* @__PURE__ */ i(G, { size: 14 })
        },
        "next"
      )
    ), t;
  }, A = Math.min(Math.max(1, (s - 1) * x + 1), l), D = Math.min(s * x, l);
  return /* @__PURE__ */ M(
    N,
    {
      w: "100%",
      justify: z ? "space-between" : "center",
      gap: "md",
      "data-plum-id": j,
      className: `${h.root} pagination ${k || ""}`,
      children: [
        /* @__PURE__ */ i(N, { gap: "xs", children: w() }),
        z && /* @__PURE__ */ M(N, { gap: "xs", align: "center", className: h.itemsPerPage, children: [
          /* @__PURE__ */ i(T, { size: "xs", c: "gray.7", children: "Items per page" }),
          /* @__PURE__ */ i(
            q,
            {
              label: "",
              data: v.map((n) => ({ value: n.toString(), label: n.toString() })),
              value: x.toString(),
              onChange: (n) => B == null ? void 0 : B(Number(n)),
              disabled: u
            }
          ),
          /* @__PURE__ */ M(T, { size: "xs", c: "gray.7", children: [
            A,
            "-",
            D,
            " ",
            "of",
            " ",
            l
          ] })
        ] })
      ]
    }
  );
};
export {
  X as Pagination
};
